// extracted by mini-css-extract-plugin
export default {"relative":"relative-a4e9"};